import { useParamsSearch } from '@anytag/shared-hooks';
import { TikTokPostReportSearchSchemaType } from '../schemaTypes';

export const useTikTokCampaignReportFilter = () => useParamsSearch<TikTokPostReportSearchSchemaType>();
